import React from "react";
import Logo from "@/components/Logo";
import { LinkedinLogo, EnvelopeSimple } from "@phosphor-icons/react";

export default function Footer() {
  const year = 2026;
  const scrollTop = (e) => {
    e.preventDefault();
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.8 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy-dark border-t border-gold/20 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-gold/15">
          {/* Brand */}
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-8 text-ink/70 leading-relaxed max-w-md font-sans-crisp">
              Consulenza strategica per imprenditori di PMI nel Nord Est Italia.
              Oltre vent'anni di esperienza CEO al servizio della tua crescita.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <p
              className="text-[0.7rem] uppercase text-gold font-sans-crisp font-semibold mb-6"
              style={{ letterSpacing: "0.28em" }}
            >
              Menu
            </p>
            <ul className="space-y-3 text-ink/75 font-sans-crisp">
              {[
                { l: "Il Problema", h: "#problema" },
                { l: "Chi Siamo", h: "#chi-siamo" },
                { l: "Metodo", h: "#metodo" },
                { l: "Servizi", h: "#servizi" },
                { l: "Diagnosi", h: "#diagnosi" },
                { l: "Contatti", h: "#contatti" },
              ].map((n) => (
                <li key={n.h}>
                  <a
                    href={n.h}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.querySelector(n.h);
                      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -40, duration: 1.5 });
                      else el?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="hover:text-gold transition-colors"
                    data-testid={`footer-link-${n.h.replace("#", "")}`}
                  >
                    {n.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p
              className="text-[0.7rem] uppercase text-gold font-sans-crisp font-semibold mb-6"
              style={{ letterSpacing: "0.28em" }}
            >
              Contatti
            </p>
            <ul className="space-y-4 text-ink/85 font-sans-crisp">
              <li>
                <a
                  href="mailto:marco@mdconsultingsas.com"
                  className="inline-flex items-center gap-3 hover:text-gold transition-colors"
                  data-testid="footer-email"
                >
                  <EnvelopeSimple size={18} weight="light" className="text-gold" />
                  marco@mdconsultingsas.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/marcodanieli73"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 hover:text-gold transition-colors"
                  data-testid="footer-linkedin"
                >
                  <LinkedinLogo size={18} weight="light" className="text-gold" />
                  linkedin.com/in/marcodanieli73
                </a>
              </li>
              <li className="text-ink/60 text-sm">
                Treviso · Veneto · Italia
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-xs text-ink/50 font-sans-crisp" data-testid="footer-copyright">
            © {year} MD Consulting S.a.s. — Tutti i diritti riservati.
          </p>
          <p
            className="text-[0.68rem] uppercase text-ink/40 font-sans-crisp"
            style={{ letterSpacing: "0.28em" }}
          >
            Crafted in Nord Est · MMXXVI
          </p>
          <button
            onClick={scrollTop}
            className="group inline-flex items-center gap-2 text-[0.7rem] uppercase text-gold hover:text-gold-light font-sans-crisp font-semibold transition-colors"
            style={{ letterSpacing: "0.28em" }}
            data-testid="footer-back-to-top"
          >
            <span>Back to Top</span>
            <span className="w-8 h-px bg-gold group-hover:w-12 transition-all" />
            <span>↑</span>
          </button>
        </div>
      </div>
    </footer>
  );
}
